import React from "react";

const Square = () => {
  return (
    <span
      role="img"
      aria-label="question-square"
      className="anticon anticon-close-square"
      style={{ fontSize: "33px" }}
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" fill="#C4C4C4" />
        <path
          d="M13.835 19.5957C13.8493 18.7435 13.946 18.0703 14.125 17.5762C14.304 17.082 14.6693 16.5342 15.2207 15.9326L16.6279 14.4824C17.2295 13.8021 17.5303 13.0716 17.5303 12.291C17.5303 11.5391 17.3333 10.9518 16.9395 10.5293C16.5456 10.0996 15.9727 9.88477 15.2207 9.88477C14.4902 9.88477 13.903 10.0781 13.459 10.4648C13.015 10.8516 12.793 11.3708 12.793 12.0225H10.8057C10.82 10.8623 11.2318 9.92773 12.041 9.21875C12.8574 8.5026 13.9173 8.14453 15.2207 8.14453C16.5742 8.14453 17.627 8.50977 18.3789 9.24023C19.138 9.96354 19.5176 10.959 19.5176 12.2266C19.5176 13.4798 18.9375 14.7152 17.7773 15.9326L16.6064 17.0928C16.0837 17.6729 15.8223 18.5072 15.8223 19.5957H13.835ZM13.749 23.001C13.749 22.6787 13.8457 22.4102 14.0391 22.1953C14.2396 21.9733 14.5332 21.8623 14.9199 21.8623C15.3066 21.8623 15.6003 21.9733 15.8008 22.1953C16.0013 22.4102 16.1016 22.6787 16.1016 23.001C16.1016 23.3232 16.0013 23.5918 15.8008 23.8066C15.6003 24.0143 15.3066 24.1182 14.9199 24.1182C14.5332 24.1182 14.2396 24.0143 14.0391 23.8066C13.8457 23.5918 13.749 23.3232 13.749 23.001Z"
          fill="white"
        />
      </svg>
    </span>
  );
};

export default Square;
